import React from 'react';

import { Ec2AdminTools } from './components/Ec2AdminTools';
import { K8SAdminTools} from './components/K8SAdminTools';

export function AdminTools({
  users,
  client,
  getLoading,
  updateLoading,
  isAdmin,
  clientInstance,
  getCloudInstance,
  createCloudInstance,
  forceRebootCloudInstance,
  delayDeleteCloudInstance,
  deleteCloudInstance,
  setProgressPercentage,
  setProgressDone,
  getClient,
  startCloudInstance,
  getClientServerState,
  serverState,
}) {
  if (!client.k8s_support) {
    return (
      <Ec2AdminTools
        client={client}
        getLoading={getLoading}
        updateLoading={updateLoading}
        isAdmin={isAdmin}
        clientInstance={clientInstance}
        getCloudInstance={getCloudInstance}
        createCloudInstance={createCloudInstance}
        forceRebootCloudInstance={forceRebootCloudInstance}
        delayDeleteCloudInstance={delayDeleteCloudInstance}
        deleteCloudInstance={deleteCloudInstance}
        setProgressPercentage={setProgressPercentage}
        setProgressDone={setProgressDone}
        getClient={getClient}
        startCloudInstance={startCloudInstance}
        getClientServerState={getClientServerState}
        serverState={serverState}
      />
    )
  }

  return (
    <K8SAdminTools
      users={users}
      client={client}
      getLoading={getLoading}
      updateLoading={updateLoading}
    />
  )
}
